const viewID = 'project_map_view';
const viewDisplayID = 'sidebar';
const formID = 'views-exposed-form-project-map-view-sidebar';
const exposedForm = document.getElementById(formID);
export const filterRadius = 1500; // 1km

/**
 * Updates a Drupal view with proximity-based filtering using latitude and longitude coordinates.
 * Proximity format should be in the following format: "40.73,-73.93<=5[unit]"
 * @param {number} latitude - The latitude coordinate to filter by
 * @param {number} longitude - The longitude coordinate to filter by
 * @throws {Error} When the fetch request fails
 * @returns {void}
 */

function getViewDOMID(viewDOMElem) {
  if (!viewDOMElem && !viewDOMElemMap) {
    console.error('No view DOM element found');
    return false;
  }

  // get view id from the class js-view-dom-id-[dom-id] from assigned class
  // first get class name that contains the dom id
  const viewDOMIDClass = viewDOMElem.className.match(/js-view-dom-id-[\w-]+/);

  // then get the dom id from the class name
  const viewDOMID = viewDOMIDClass[0].replace('js-view-dom-id-', '');

  return viewDOMID;
}

function executeAJax(viewDOMID, displayID, extendedParams) {
  // Construct query parameters
  const params = new URLSearchParams({
    view_name: viewID,
    view_display_id: displayID,
    view_dom_id: viewDOMID,
    view_path: drupalSettings.path.currentPath,
    view_base_path: drupalSettings.path.baseUrl,
    pager_element: 0,
    ...extendedParams
  });

  const inputs = exposedForm.getElementsByTagName('INPUT');
  Array.from(inputs).forEach(element => {
    if (element.checked)
      params.append(`field_status_target_id[${element.value}]`, element.value);
  });

  const queryParams = params.toString();

  // get view object from the view dom id
  const ajaxSettings = {
    url: `/views/ajax?${queryParams}`,
    method: 'GET',
    success: function (response) {
      // Let Drupal handle the response automatically
      Drupal.Ajax.prototype.success.call(this, response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.error('AJAX error:', textStatus, errorThrown);
    }
  };

  // console.log('AJAX settings:', ajaxSettings);
  const ajax = new Drupal.Ajax(false, document.body, ajaxSettings);
  ajax.execute();
}

function getProximityValue(latitude, longitude) {
  return `${latitude},${longitude}<=${filterRadius}km`;
}

export function updateListWithProxymityFilter(latitude, longitude) {
  const params = {};

  if (latitude && longitude) {
    const proximityValue = getProximityValue(latitude, longitude);
    params.view_args = proximityValue;
  }

  // perform sidebar change
  const viewDOMElem = document.querySelector(
    `.view-display-id-${viewDisplayID}`
  );
  const viewDOMID = getViewDOMID(viewDOMElem);
  executeAJax(viewDOMID, viewDisplayID, params);
}

/**
 * Retrieves geolocation coordinates from a text input using the ArcGIS geocoding service
 * @param {string} searchAddress - The address or location text to geocode
 * @returns {Promise<{latitude: number, longitude: number}>} A promise that resolves to an object containing latitude and longitude
 * @throws {Error} Throws an error if no location is found
 * @example
 * getGeolocationFromInput("Melbourne, Australia")
 *   .then(coords => console.log(coords))
 *   .catch(err => console.error(err));
 */
export function getCoordinatesFromAddress(searchAddress) {
  const arcgisUrl = `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates?address=${encodeURIComponent(
    searchAddress
  )}&f=json`;

  return fetch(arcgisUrl)
    .then(response => response.json())
    .then(data => {
      if (data.candidates && data.candidates.length > 0) {
        const location = data.candidates[0].location;
        return {
          latitude: location.y,
          longitude: location.x
        };
      }
      throw new Error('No location found');
    });
}
